import React from "react";
import classNames from "classnames";

import Modal, { OutsideClickModes } from "src/app/components/Modal/Modal";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { MaterialTooltip } from "src/app/components/MaterialTooltip/MaterialTooltip";
import VelocityIcon from "../VelocityIcon/VelocityIcon";
import PostInfo from "../../campaign-details/PostInfo/PostInfo";
import UserInterestList from "../UserInterestList/UserInterestList";
import Loader from "../../components/Loader/Loader";
import VelocityItems from "./VelocityItems";
import { generateVelocityIndexModalTooltip } from "../../helpers/velocityIndexTooltip";

import "./VelocitySummaryModal.scss";

export default function VelocitySummaryModal({
  onClose,
  velocitySummary,
  searchAudienceFilters,
}) {
  const {
    userId,
    profilePictureUrl,
    socialProvider,
    socialUsername,
    followersCount,
    audienceInterests,
    velocityIndex,
    velocityIndexSubmetrics,
    profileUrl,
  } = velocitySummary ?? {};

  const { chosenTopics } = searchAudienceFilters ?? {};

  return (
    <Modal
      className="velocity-modal"
      onClose={onClose}
      displayCancelButton
      title={
        <IDHFormattedMessage
          id="front_modal_relevance_breakdown"
          defaultMessage="Relevance breakdown"
        />
      }
      displayCloseIcon
      outsideClick={OutsideClickModes.Allow}
    >
      {userId ? (
        <div className="velocity">
          <div
            className={classNames("velocity__top", {
              "velocity__top--tt":
                socialProvider === "tik_tok" ||
                socialProvider === "douyin" ||
                socialProvider === "youtube" ||
                socialProvider === "facebook" ||
                socialProvider === "snapchat",
            })}
          >
            <div
              className={
                socialProvider === "instagram" ? "velocity__info" : null
              }
            >
              <div className="velocity__user">
                <div
                  className="velocity__photo"
                  style={{
                    backgroundImage: `url(${profilePictureUrl})`,
                  }}
                />
                <PostInfo
                  post={{
                    socialProfileUrl: profileUrl,
                    cpconExternalContent: null,
                    cpcon: null,
                    socialProvider,
                    socialUserName: socialUsername,
                    followersCount,
                  }}
                />
              </div>
              {socialProvider === "instagram" && (
                <div className="velocity__interests">
                  <div className="velocity__interests-header">
                    <IDHFormattedMessage
                      id="front_audience_interests"
                      defaultMessage="Audience interests"
                    />
                  </div>

                  <UserInterestList
                    interestList={audienceInterests}
                    selectedInterest={chosenTopics || []}
                  />
                </div>
              )}
            </div>
            <div
              className={
                socialProvider === "instagram" ? "velocity__stats" : null
              }
            >
              <div className="velocity__header">
                <IDHFormattedMessage
                  id="front_relevance"
                  defaultMessage="relevance"
                />
                <MaterialTooltip
                  center
                  alignRight
                  content={generateVelocityIndexModalTooltip(socialProvider)}
                />
              </div>

              <div
                className={classNames("velocity__box", {
                  "velocity__box--high": (velocityIndex || 0) > 50,
                  "velocity__box--low": (velocityIndex || 0) === 0,
                })}
              >
                <VelocityIcon percent={velocityIndex || 0} />
                {velocityIndex || 0}
              </div>
              {socialProvider === "instagram" && (
                <VelocityItems
                  velocityIndexSubmetrics={velocityIndexSubmetrics}
                  socialProvider={socialProvider}
                />
              )}
            </div>
          </div>
          {(socialProvider === "tik_tok" ||
            socialProvider === "douyin" ||
            socialProvider === "youtube") && (
            <VelocityItems
              velocityIndexSubmetrics={velocityIndexSubmetrics}
              socialProvider={socialProvider}
            />
          )}
        </div>
      ) : (
        <Loader />
      )}
    </Modal>
  );
}
